import ApplicationController from '../../support/application_controller'
import $fq                   from '../../support/fake_query'
import BmiMixin              from '../../support/bmi_mixin'
import mixin                 from '../../support/mixin'

export default class extends mixin(ApplicationController, BmiMixin) {

  static outlets = [
    'consultation'
  ]

  // ==== Actions

  renderResponse(event) {
    const [_response, _status, xhr] = event.detail

    $fq(this.consultationOutlet.responseBodyTarget).html(xhr.response)
  }

  // ==== Getters

  // ==== Setters

  // ==== Private

  // ==== Channels

}
